exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "html {\n    /* height: 100%; */\n}\n\nbody {\n    /* min-height: 100%; */\n    font-family: Verdana, sans-serif;\n}\n\n#root {\n    min-height: 100vh;\n}\n", "", {"version":3,"sources":["/home/jenkins/workspace/buch-editor-frontend_master-HFHSIVOQ6IJI5ZBPHCHU7A6EKU7FAGJSAKF6XQUXPUJGATAUMFRQ/src/styles/app.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;CACtB;;AAED;IACI,uBAAuB;IACvB,iCAAiC;CACpC;;AAED;IACI,kBAAkB;CACrB","file":"app.css","sourcesContent":["html {\n    /* height: 100%; */\n}\n\nbody {\n    /* min-height: 100%; */\n    font-family: Verdana, sans-serif;\n}\n\n#root {\n    min-height: 100vh;\n}\n"],"sourceRoot":""}]);

// exports
